import type { FC } from 'react';
import { useRef } from 'react';
import type { ActionFieldsOptions } from '../../types';
import useRulePageMode from '../../hooks/useRulePageMode';
import { MenuItem, Select } from '@mui/material';

export const ActionTypeFieldSelect: FC<{
  onChange: (value: ActionFieldsOptions) => void;
  value: string;
  disabled?: boolean;
}> = ({ onChange, value, disabled }) => {
  const { isRead } = useRulePageMode();
  const typeFields = useRef<{ id: ActionFieldsOptions; label: string }[]>([
    { id: 'metric', label: 'Metric value' },
    { id: 'absolute', label: 'Number value' },
  ]);

  return (
    <Select
      disabled={disabled ?? isRead}
      variant={'outlined'}
      value={value}
      onChange={(e) => {
        onChange(e.target.value as ActionFieldsOptions);
      }}
      sx={{
        '&.MuiInputBase-root, &.MuiInputBase-root fieldset': { border: 'none' },
        '&.MuiInputBase-root': {
          minHeight: 24,
          maxHeight: 24,
          mt: 0.25,
        },
        '.MuiSelect-select': {
          minWidth: 90,
        },
      }}
    >
      {typeFields.current.map(({ id, label }) => (
        <MenuItem key={id} value={id}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ActionTypeFieldSelect;
